import { Card, CardContent } from "@mui/material";
import type { StatisticsReport } from "../../lib/types";
import { formatCurrency } from "./formatters";

function formatPercent(value: number) {
  return `${value > 0 ? "+" : ""}${Math.round(value)}%`;
}

function deltaText(value: string | number, currency: string, percent?: number | null) {
  if (percent === undefined || percent === null) return { text: "No comparison", className: "stat-delta" };
  const amount = Number(value || 0);
  return { text: `${amount > 0 ? "+" : ""}${formatCurrency(amount, currency)} (${formatPercent(percent)})`, className: amount > 0 ? "stat-delta positive" : amount < 0 ? "stat-delta negative" : "stat-delta" };
}

export function StatisticsKpis({ report, currency }: { report: StatisticsReport; currency: string; previousLabel: string }) {
  const income = Number(report.totals.income);
  const savingsRate = income > 0 ? (Number(report.totals.net) / income) * 100 : null;
  const incomeDelta = deltaText(report.comparison.income_delta, currency, report.comparison.income_percent);
  const netDelta = deltaText(report.comparison.net_delta, currency, report.comparison.net_percent);
  return (
    <Card className="records-panel statistics-summary-card"><CardContent className="statistics-summary-grid">
      <div><span>Income</span><strong>{formatCurrency(report.totals.income, currency)}</strong><small className={incomeDelta.className}>{incomeDelta.text}</small></div>
      <div><span>Net cash flow</span><strong>{formatCurrency(report.totals.net, currency)}</strong><small className={netDelta.className}>{netDelta.text}</small></div>
      <div><span>Savings rate</span><strong>{savingsRate === null ? "—" : `${Math.round(savingsRate)}%`}</strong><small>Net of income kept</small></div>
    </CardContent></Card>
  );
}
